// extracted by mini-css-extract-plugin
export default {"container":"AttendanceTable_container__CJh5r","table":"AttendanceTable_table__z-3Rm"};